module.exports = __webpack_public_path__ + "img/primaire.93d2e309.png";